import React from 'react'
// https://www.npmjs.com/package/react-spinners

import { SpinnerStyle } from './style'
//import { VARIABLES } from 'themes'

export class Spinner extends React.PureComponent {
  render() {
    const { className } = this.props
    return (
      <SpinnerStyle className={className}>
        <svg
          width="80"
          height="80"
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid"
        >
          <circle
            cx="50"
            cy="50"
            fill="none"
            stroke="#4b4acb"
            strokeWidth="10"
            r="35"
            strokeDasharray="164.93361431346415 56.97787143782138"
            transform="rotate(275.845 50 50)"
          >
            <animateTransform
              attributeName="transform"
              type="rotate"
              calcMode="linear"
              values="0 50 50;360 50 50"
              keyTimes="0;1"
              dur="1s"
              begin="0s"
              repeatCount="indefinite"
            />
          </circle>
        </svg>
      </SpinnerStyle>
    )
  }
}
